export default __webpack_public_path__ + "static/9001-935ec07beca0b28cbe33a9c4ee0d3321.png";